import React from "react";
import { MegaphoneIcon } from "@heroicons/react/24/outline";
import ClearCacheButton from "./ClearCacheButton";
import { useVisibleDashboardNotification } from "../hooks/useVisibleDashboardNotification";

export default function DashboardNotificationBanner() {
  const { bannerNotification, showClearCacheInBanner } = useVisibleDashboardNotification();

  if (!bannerNotification?.message) return null;

  return (
    <div
      className="border-b border-amber-200 bg-amber-50 px-3 py-3 text-amber-950 shadow-sm sm:px-4"
      role="alert"
    >
      <div className="mx-auto flex max-w-7xl items-start gap-2 sm:gap-3">
        <MegaphoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
        <p className="min-w-0 flex-1 break-words text-sm font-medium leading-5">
          {bannerNotification.message}
        </p>
        {showClearCacheInBanner && (
          <div className="ml-auto shrink-0 self-start">
            <ClearCacheButton variant="banner" />
          </div>
        )}
      </div>
    </div>
  );
}
